import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';
import { Permission } from '~/types/Permission';

import { checkIsAdmin } from './checkIsAdmin';
import { and } from './utils/and';

const useUsersPage = () => {
  const userPermission = useFlag(FlagType.NewUsersPage);
  return userPermission;
};
export const canUseUsersPage: Permission = and([useUsersPage, checkIsAdmin]);
